module.exports = __webpack_public_path__ + "static/media/B3.c76fa9ea.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B3.png
// module id = 882
// module chunks = 0